module.exports = __webpack_public_path__ + "appcivico-logo--f85e3b01.svg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/header/appcivico-logo.svg
// module id = 115
// module chunks = 0